module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDxzeW1ib2wgaWQ9InRyaWFuZ2xlIiBvdmVyZmxvdz0idmlzaWJsZSIKCXByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHZpZXdCb3g9IjAgMCA1MCA1MCI+CiAgICAgIDxkZXNjPnRyaWFuZ2xlPC9kZXNjPgogICAgICA8cG9seWdvbiBzdHJva2U9ImN1cnJlbnRDb2xvciIgcG9pbnRzPSIxLDQ5IDQ5LDI0IDEsMSIvPgogICAgPC9zeW1ib2w+CiAgPC9kZWZzPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/icons/triangle.svg
// module id = 710
// module chunks = 0